import {
    createObservableDataAction,
    IActionContext,
    IAction,
    ICreateActionContext,
    IGeneric,
    IAny,
    ICommerceApiSettings
} from '@msdyn365-commerce/core';
import {
    callActionOrExecute,
    DataServiceQuery,
    IDataServiceRequest,
    CustomerBalances,
    IActionInput,
    CacheType
} from '@msdyn365-commerce/retail-proxy';

export class GetOrganizationBalanceInput implements IActionInput {
    constructor(apiSettings: ICommerceApiSettings) {}

    public getDataServiceRequest = (): IDataServiceRequest => {
        const query = new DataServiceQuery();
        return query.createDataServiceRequestForOperation(
            'GetOrganizationBalance',
            true,
            'CustomerBalances',
            'false',
            { bypassCache: 'get', returnEntity: 'CustomerBalances' },
            {}
        );
    };

    public shouldCacheOutput = (): boolean => false;

    public getCacheKey = () => `OrganizationBalance`;
    public getCacheObjectType = () => 'CustomerBalances';
    public dataCacheType = (): CacheType => 'none';
}

export const getOrganizationBalanceAction = async (input: GetOrganizationBalanceInput, ctx: IActionContext): Promise<CustomerBalances> => {
    const request = input.getDataServiceRequest();
    return callActionOrExecute<CustomerBalances>(request, ctx);
};

export const getOrganizationBalance = createObservableDataAction({
    id: 'defa/get-organization-balance',
    action: <IAction<CustomerBalances>>getOrganizationBalanceAction,
    input: (inputData: ICreateActionContext<IGeneric<IAny>>): GetOrganizationBalanceInput =>
        new GetOrganizationBalanceInput(inputData.requestContext.apiSettings)
});

export default getOrganizationBalance;
